import { Image } from "ol/layer";
import ImageArcGISRest from "ol/source/ImageArcGISRest";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
export class LabelLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
        this.default_params = {};
        this.url = "";
    }
    validate(opts) {
        let result = true;
        result && (result = !!opts.name);
        result && (result = typeof opts.exportUrl === 'string');
        return result;
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    async parse_config(opts) {
        var _a, _b;
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        const api = await this.get_service_api([opts.infoUrl]);
        if (!api) {
            console.error(`Label layer "${opts.name}" loading failed. See console logs.`);
            this.parsing_failed = true;
            return;
        }
        ;
        this.projection = api.projection;
        this.default_params = structuredClone(opts.details);
        this.url = api.endpoints[0];
        if (api.token) {
            opts.details = {
                ...opts.details,
                token: api.token
            };
        }
        let layer = new Image({
            source: new ImageArcGISRest({
                params: structuredClone(opts.details),
                url: api.endpoints[0],
                crossOrigin: 'anonymous',
                hidpi: true,
                ratio: 1,
            }),
            visible: opts.visible,
            opacity: opts.opacity
        });
        layer.set('name', opts.name);
        this.raw = new Some(layer);
        (_a = layer.getSource()) === null || _a === void 0 ? void 0 : _a.on("imageloadstart", () => {
            this.display_loading_indicator(true);
        });
        (_b = layer.getSource()) === null || _b === void 0 ? void 0 : _b.on("imageloadend", () => {
            this.display_loading_indicator(false);
        });
    }
    get_layer_num(layer_nums) {
        return layer_nums.split(',')[0].trim();
    }
    get_url() {
        var _a, _b, _c;
        if (!((_a = this.opts) === null || _a === void 0 ? void 0 : _a.infoUrl))
            return null;
        if (!((_c = (_b = this.opts) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.LAYERS))
            return null;
        const layer_nums = this.opts.details.LAYERS.split(':')[1];
        if (!(layer_nums && layer_nums.length))
            return null;
        let layer_num = this.get_layer_num(layer_nums);
        if (!layer_num.length)
            return null;
        return this.opts.infoUrl + `/${layer_num}`;
    }
    async is_kml_download_supported() {
        return await this.is_query_supported();
    }
    async is_query_supported() {
        const url = this.get_url();
        if (!url)
            return false;
        const res = await fetch(url + "?f=json");
        if (!res.ok)
            return false;
        const info = await res.json();
        if (info.capabilities && info.capabilities.includes("Query")) {
            const res = await fetch(url + `/query?where=1=1&outFields=*&f=json&resultRecordCount=${1}`);
            if (!res.ok)
                return false;
            const info = await res.json();
            if (info.error)
                return false;
            return true;
        }
        return false;
    }
    async is_geojson_format_supported() {
        const url = this.get_url();
        if (!url)
            return false;
        const res = await fetch(url + `/query?where=1=1&outFields=*&f=geojson&resultRecordCount=${1}`);
        if (!res.ok)
            return false;
        const info = await res.json();
        if (!info.error) {
            return true;
        }
        return false;
    }
    async downloadKml() {
        var _a, _b, _c, _d, _e;
        if (this.raw.isNone())
            return;
        this.display_loading_indicator(true);
        try {
            const layer_nums = (_c = (_b = (_a = this.opts) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.LAYERS) === null || _c === void 0 ? void 0 : _c.split(':')[1];
            if (!layer_nums)
                throw new Error("could not parse layer number from config");
            let layer_num = this.get_layer_num(layer_nums);
            const url = ((_d = this.opts) === null || _d === void 0 ? void 0 : _d.infoUrl) + `/${layer_num}`;
            await ((_e = this.map) === null || _e === void 0 ? void 0 : _e.download_complete_layer_kml(this.name, url));
        }
        catch (error) {
            console.error(`unable to download ${this.name} kml data. ${error}`);
        }
        this.display_loading_indicator(false);
    }
}
